/**
 * Pipeline table: row expand/collapse and overview toggle
 */
export class PipelineTable {
    init() {
        const rows = document.querySelectorAll("[data-pipeline-row]");
        const summaries = document.querySelectorAll(
            ".no-pipeline-table__summary-row"
        );
        if (!rows.length || rows.length !== summaries.length) return;

        rows.forEach((row, i) => {
            row.addEventListener("click", (e) => {
                if (e.target.closest("a")) return;
                const summary = summaries[i];
                summary.hidden = !summary.hidden;
                row.classList.toggle("is-expanded", !summary.hidden);
            });
        });

        const overviewToggle = document.getElementById("pipeline-overview-toggle");
        const overviewContent = document.getElementById(
            "pipeline-overview-content"
        );
        if (overviewToggle && overviewContent) {
            overviewToggle.addEventListener("click", () => {
                overviewContent.hidden = !overviewContent.hidden;
                overviewToggle.setAttribute(
                    "aria-expanded",
                    overviewContent.hidden ? "false" : "true"
                );
                overviewToggle.classList.toggle(
                    "is-open",
                    !overviewContent.hidden
                );
            });
        }
    }
}
